var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{'in-progress':_vm.loadInProgress}},[_c('div',{staticClass:"spinner-border text-primary"})])
}
var staticRenderFns = []

export { render, staticRenderFns }